import { Typography, styled } from '@mui/material'

export const StyledNameTypography = styled(Typography)(({ theme }) => ({
  position: 'relative',
  '&:after': {
    content: "' '",
    width: '100%',
    height: '1px',
    display: 'block',
    position: 'absolute',
    bottom: -2,
    backgroundColor: theme.palette.text.primary,
    [theme.breakpoints.up('md')]: {
      content: 'none',
    },
  },
}))
